.<template>
    <div class="panel-full panel guestfull" v-show="isActive">
      
        
        <div>
            

            <!-- takeout -->
            <div class="innerpanelculinary">
                <div class="horizFlex guestentry">
                    
                    <label class="guestlabel ">Guest Name</label>
                    <input class="takeoutinput capital" v-model="guestName_Culinary"   />
           
                </div>
                <br></br>
                <div class="horizFlex guestentry">
                    
                    <label class="guestlabel ">Guest Phone</label>
                    <input class="takeoutinput capital" v-model="guestPhone_Culinary" @input="changeGuestName" @keyup.enter="AddTicket_Culinary(false)" />
                    <button class="btn-tocart " @click="AddTicket_Culinary(false)" v-show="isValid &&  ticket.id==0">Continue to Cart</button>
                </div>
            </div>
        </div>
        

        <div v-if="pleaseWait">
          <label class="pleasewait" for>Please Wait...</label>
        </div>

        <div>

        </div>
  

    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import format from '../../style/format.js'
  import dataModel from '../../store/dataModel'
  import linkbutton from '../controls/linkbutton.vue'
  import optionbutton from '../controls/optionbutton.vue'
  import optionbuttonstringid from '../controls/optionbuttonstringid.vue'
  import entry from '../controls/entry.vue'
  import pos from '../../services/pos.js'
  import pos_culinary from '../../services/pos_culinary.js'
  export default {
    components:{
        linkbutton,
        optionbutton,
        entry,
        optionbuttonstringid
    },
    data() {
      return {
        paramTrue:true,
        param1:1,
        inEdit:false
        

      };
    },
    mixins:[dataModel,format,pos, pos_culinary],
    props: ["panelIndex"],
    computed: {
      ...mapFields([
              'panels',
              
          ]),
          
      isActive: function() {
        return this.panels[this.panelIndex].active;
      },
      isValid: function() {
        return this.panels[this.panelIndex].valid;
      },
      priorValid: function() {
        return this.panels[this.panelIndex - 1].valid;
      },
      dineInSelected(){
        return this.ticketType_Culinary=='Dine In'
      },
      takeoutSelected(){
        return this.ticketType_Culinary=='Take Out'
      },
      isNewTicket(){
        return this.ticket.id==0
      },
      isReservationTicket(){
        return this.ticket.id>0 && this.ticket.seatingId>0 && this.ticket.employeeId==0
      },
      disableCulinaryOptions(){
        if(this.isReservationTicket){
          return false
        }
        else if(this.ticket.id>0 && !this.inEdit){
          return true
        }else{
          return false
        }
      }
    },
    watch:{
      isActive:function(val){
        if(this.isActive){this.show()}
      }
    },
    methods: {
     show(){

        this.getEmployeeList_Culinary()
        this.GetPrepAreas()
      this.$nextTick(() => {
        
      })
     },
     
     
     
     
        
        
        isSelected(g){
          return g.id==this.guest.id
        },
 
        
      toNext: function() {

        var nextPanelIndex = Number(this.panelIndex) + 1;
        this.$store.dispatch('setActivePanel',nextPanelIndex); 
      },
      save(){
        //save stuff
        this.AddTicket_Culinary(false,true)
        this.inEdit=false
      }
     
    },
    mounted(){
        this.show()
    }
  };
  </script>
  
  <style scoped>
  .guestfull {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 80px auto 80px;
    grid-template-areas:
      "lookup"
      "details"
      "next";
  }
  .toggle{
    background-color: blue;
  }
  .togglehighlight{
    background-color: yellow;
  }
.innerpanelculinary{
    margin:40px;
}
.marginbottom{
    margin-bottom:30px;
}
.margintop{
    margin-top:20px;
}
.guestlabel{
    margin-right:20px;
}
.guestentry{
    width:500px;
}
.employeediv{
  max-width:90%;
  max-height:150px;
  overflow-y: auto;
  overflow-x:hidden;
}
.capital{
  text-transform: capitalize;
}
.takeoutinput{
  height:20px;
  margin:0px;
}
.btn-tocart {
  background-color: var(--button-color);
  color: var(--light-text-color);
  margin: 0px 0px 0px 10px;
  border: none;
  font-size: inherit;
  border-radius: var(--border-radius-default);
  padding: var(--padding-smaller);
}
  </style>